// extracted by mini-css-extract-plugin
export default {"raiz":"PainelPremium_raiz__XGQnn","brilhoCentro":"PainelPremium_brilhoCentro__WgfjT","brilhoTopo":"PainelPremium_brilhoTopo__svIOI","coluna":"PainelPremium_coluna__SvWC1"};